//libs
import { withSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import cx from "classnames";

//components
import { BreadcrumbMenu, CountCard, PieChart } from "src/components";

//constants
import { ChartColors, STRINGS } from "src/shared/constants";

//styles
import S from "./style.module.scss";
import { RecentUsersTable } from "./widgets";

const Dashboard = ({
  getDashboardData = () => {},
  enqueueSnackbar = () => {},
  loading = false,
}) => {
  const [data, setData] = useState({});

  useEffect(() => {
    getDashboardData({
      payload: {},
      success: (data) => {
        setData(data);
      },
      fail: (msg) => {
        enqueueSnackbar(msg, { variant: "error" });
      },
    });
    // eslint-disable-next-line
  }, []);

  return (
    <section className={S.section}>
      <BreadcrumbMenu title={STRINGS.DASHBOARD} />
      {!loading && (
        <>
          <div className={S.cardContainer}>
            <CountCard
              title={"Total Users"}
              count={data.totalUsers}
              background={ChartColors.green()}
            />
            <CountCard
              title={"Primary Users"}
              count={data.totalPrimaryUsers}
              background={ChartColors.blue()}
            />
            <CountCard
              title={"Secondary Users"}
              count={data.totalSecondaryUsers}
              background={ChartColors.lightBlue()}
            />
            {!!data.totalProviders && (
              <CountCard
                title={"Providers"}
                count={data.totalProviders}
                background={ChartColors.lightGreen()}
              />
            )}
          </div>
          <div className={S.chart}>
            <div className={cx(S.chartContainer, S.chartPie)}>
              <PieChart title={"Users Chart"} height={300} dataSet={data} />
            </div>

            <div className={S.tableContainer}>
              <p className={S.tableHeading}>Recent Users</p>
              <RecentUsersTable data={data?.top10Users?.rows || []} />
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default withSnackbar(Dashboard);
